import React from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import ArrowIcon from 'Assets/Images/icons/arrow'
import { globalSort } from '../../../shared/libraries/sort'

const getSelectOptions = ({ options, sorted, ASC }) => {
  if (sorted) {
    return globalSort({
      data: options,
      sortingKey: 'label',
      ASC,
    })
  } else {
    return options
  }
}

/**
 * @param {{className, hasPrimaryText, primaryText, options}} props
 */
export const SelectUnstyled = props => {
  const onChange = props.onChange
    ? props.onChange
    : (e, index, value) => props.input.onChange(value)
  let value = props.input ? props.input.value : null

  if (props.value) {
    value = props.value
  }
  const options = getSelectOptions({
    options: props.options,
    sorted: props.sorted,
    ASC: props.ASC,
  })

  return (
    <div className={`${props.className} form-select`}>
      <SelectField
        autoWidth={!!props.autoWidth}
        className="select-field"
        onChange={onChange}
        value={value}
        iconStyle={{
          fill: 'none',
        }}
        disabled={props.disabled}
      >
        {props.hasPrimaryText && (
          <MenuItem primaryText={props.primaryText} value={null} />
        )}
        {options.map((option, idx) => (
          <MenuItem key={idx} primaryText={option.label} value={option.value} />
        ))}
      </SelectField>
      <ArrowIcon />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Form/Select/unstyled.js